export default {
  "404": () => import("/__w/landing-page/landing-page/layouts/404.vue"),
  default: () => import("/__w/landing-page/landing-page/layouts/default.vue")
}